import reducerRegistry from '@comeon/reducer-registry';
import {
	VERIFY_CODE,
	VERIFY_EMAIL,
	UPDATE_PASSWORD,
	CLOSE_MESSAGE,
	VERIFY_CODE_FAILURE,
	UPDATE_RESET_PASSWORD_CREDENTIALS,
	RESET_PASSWORD_RESET,
	SHOW_DOB_FORGETPASSWORD,
	SET_DATE_OF_BIRTH
} from './action-names';
import preloadedState from './preloaded-state';
import { ResetPasswordActions } from '../reset-password.types';

const REDUCER_NAME = 'resetPassword';

function reducer(
	// eslint-disable-next-line @typescript-eslint/default-param-last
	state = preloadedState,
	{ type, payload }: ResetPasswordActions
) {
	switch (type) {
		case VERIFY_EMAIL:
			return {
				...state,
				identifier: payload?.identifier,
				type: payload?.type
			};
		case VERIFY_CODE:
			return {
				...state,
				identifier: payload?.identifier,
				type: payload?.type,
				code: payload?.code,
				name: payload?.name
			};
		case VERIFY_CODE_FAILURE:
			return {
				...state,
				shouldShowMessage: payload
			};
		case UPDATE_PASSWORD:
			return {
				...state,
				identifier: payload?.identifier,
				type: payload?.type,
				code: payload?.code
			};
		case CLOSE_MESSAGE:
		case RESET_PASSWORD_RESET:
			return {
				shouldShowMessage: {
					status: false,
					title: '',
					msg: '',
					supportButton: '',
					closeButton: ''
				},
				identifier: '',
				type: '',
				code: ''
			};
		case UPDATE_RESET_PASSWORD_CREDENTIALS:
			return {
				...state,
				identifier: payload?.identifier,
				type: payload?.type,
				code: payload?.code
			};
		case SHOW_DOB_FORGETPASSWORD:
			return {
				...state,
				showDOBVerification: payload?.showDOBVerification
			};
		case SET_DATE_OF_BIRTH:
			return {
				...state,
				dateOfBirth: payload?.dateOfBirth
			};
		default:
			return state;
	}
}

reducerRegistry.register(REDUCER_NAME, reducer);

export default reducer;
